<a *ngIf="partId | buildPartLink:partNumber as href; else partNumberTmpl"
   target="_blank"
   [href]="href"
   [style.color]="styled ? 'inherit' : ''"
   [class.clickable-item]="styled">
    {{ name }}
</a>
<ng-template #partNumberTmpl>
    {{ name }}
</ng-template>
